module.exports = __webpack_public_path__ + "img/elec_inner_pic2.b279f027.png";